import { configureStore } from "@reduxjs/toolkit";
import { loadState, saveState } from "../utility/LocalStorage";
import reducer from "./reducers/Reducers";
// Redux Toolkit includes 'thunk' by default, no need to import it separately.

const persistedState = loadState();

const rootReducer = {
  root: reducer,
};

const store = configureStore({
  reducer: rootReducer,
  preloadedState: persistedState,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(),
});

store.subscribe(() => {
  saveState(store.getState());
});

export default store;
